import React, { useEffect, useRef, useState } from 'react';
import { Pause, Play } from 'lucide-react';

const films = [
  { name: 'Kidsplace', source: '/media/homepage/videos/4_kidsplace.webm', poster: '/media/studio/kidsplace-poster.jpg' },
  { name: 'Vvaan', source: '/media/homepage/videos/1_vvaan.webm', poster: '/media/studio/vvaan-poster.jpg' },
  { name: 'Headphones', source: '/media/homepage/videos/2_headphone.webm', poster: '/media/studio/headphone-film-poster.jpg' },
];

export default function LandingShowcase() {
  const [selected, setSelected] = useState(1);
  const [wantsPlayback, setWantsPlayback] = useState(false);
  const [inView, setInView] = useState(false);
  const [visible, setVisible] = useState(true);
  const [failed, setFailed] = useState(false);
  const root = useRef(null);
  const video = useRef(null);
  const progress = useRef(null);

  useEffect(() => {
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    setWantsPlayback(!motion.matches && !navigator.connection?.saveData);
    const changeMotion = () => setWantsPlayback(!motion.matches && !navigator.connection?.saveData);
    const changeVisibility = () => setVisible(!document.hidden);
    motion.addEventListener('change', changeMotion);
    document.addEventListener('visibilitychange', changeVisibility);
    const observer = new IntersectionObserver(([entry]) => setInView(entry.isIntersecting), { threshold: 0.15 });
    observer.observe(root.current);
    return () => {
      observer.disconnect();
      motion.removeEventListener('change', changeMotion);
      document.removeEventListener('visibilitychange', changeVisibility);
    };
  }, []);

  useEffect(() => {
    const element = video.current;
    if (!element) return;
    if (wantsPlayback && inView && visible) {
      element.play().catch(error => { if (error.name !== 'AbortError' && video.current === element) setWantsPlayback(false); });
    } else element.pause();
  }, [selected, wantsPlayback, inView, visible, failed]);

  return <div id="sample-films" className="studio-showcase" ref={root}>
    <div className="studio-showcase-films" role="group" aria-label="Choose a sample film">
      {films.map((film, index) => <button key={film.source} type="button" className={`studio-showcase-film ${index === selected ? 'is-selected' : ''}`} aria-pressed={index === selected} aria-label={`Preview ${film.name}`} onClick={() => { setSelected(index); setFailed(false); }}>
        <img src={film.poster} alt="" width="540" height="960" fetchPriority={index === 1 ? 'high' : 'auto'} />
        {index === selected && !failed && <video ref={video} src={film.source} poster={film.poster} muted loop playsInline preload="metadata" aria-hidden="true" onError={() => { setFailed(true); setWantsPlayback(false); }} onTimeUpdate={event => { if (progress.current) progress.current.style.transform = `scaleX(${event.currentTarget.currentTime / (event.currentTarget.duration || 1)})`; }} />}
        <span className="studio-showcase-film-caption"><span>{film.name}</span><Play size={15} fill={index === selected ? 'currentColor' : 'none'} aria-hidden /></span>
      </button>)}
    </div>
    <div className="studio-showcase-transport">
      <div><p>See a still become a scene.</p><span>Films generated with the new Adfini engine.</span></div>
      <div className="studio-showcase-playback"><span>{failed ? 'Preview unavailable. Choose another film.' : films[selected].name}</span><button type="button" disabled={failed} onClick={() => setWantsPlayback(value => !value)} aria-label={wantsPlayback ? 'Pause sample film' : 'Play sample film'}>{wantsPlayback ? <Pause size={17} aria-hidden /> : <Play size={17} aria-hidden />}<span>{wantsPlayback ? 'Pause' : 'Play'}</span></button></div>
    </div>
    <div className="studio-showcase-progress" aria-hidden="true"><span ref={progress} key={selected} /></div>
  </div>;
}
